import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/nutrilens-logo.png";
import Footer from "./Footer";
import { IoMenu, IoClose } from "react-icons/io5";
import { IoChevronUp } from "react-icons/io5";
import "./privacyPolicy.css";
import { termsAndConditionsContent } from "../constants/legalContent";

const TermsAndCondition = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const sidebarRef = useRef(null);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebar(false);
      }
    };

    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScroll = () => {
    if (headerRef.current) {
      if (window.scrollY > 200) {
        headerRef.current.classList.add("shadow-lg");
      } else {
        headerRef.current.classList.remove("shadow-lg");
      }
    }
    if (window.scrollY > 200) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="px-8 lg:px-32 xl:px-52 bg-white ">
        <header
          ref={headerRef}
          className={`text-black z-10 bg-white ${
            isLargeScreen ? "" : "fixed top-0 left-0 right-0 w-full"
          }`}
          style={{ width: "100%" }}
        >
          <div className="container mx-auto flex items-center justify-between h-[80px] px-8 md:px-0">
            <Link to="/" className="flex items-center gap-2">
              <img
                src={Logo}
                alt="NutriLens AI logo"
                className="w-11 h-11 rounded-xl object-cover"
              />
              <span className="text-xl font-extrabold text-[#12AD63]">
                NutriLens <span className="text-[#2b2b2b]">AI</span>
              </span>
            </Link>

            {/* Mobile Menu Icon */}
            {!isLargeScreen && (
              <div className="flex items-center absolute top-0 right-0 p-4 z-10">
                <button onClick={() => setShowSidebar(true)}>
                  <IoMenu size={30} className="text-black" />
                </button>
              </div>
            )}

            {/* Desktop Menu */}
            {isLargeScreen && (
              <nav className="hidden md:flex flex-col md:flex-row" key="nav">
                <Link
                  to="/"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold text-black hover:text-[#12AD63] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Home
                </Link>
                <Link
                  to="/terms-and-condition"
                  className="mx-4 mb-2 md:mb-0 font-body font-semibold text-black hover:text-[#12AD63] mt-2"
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    textDecoration: "none",
                  }}
                >
                  Terms & Conditions
                </Link>
              </nav>
            )}
          </div>
        </header>

        {/* Mobile Sidebar Menu */}
        {showSidebar && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
            <div
              ref={sidebarRef}
              className="fixed top-0 right-0 h-full bg-white shadow-lg p-4"
              style={{ width: "300px" }}
            >
              <button
                onClick={() => setShowSidebar(false)}
                className="absolute top-4 right-4"
              >
                <IoClose size={30} className="text-black" />
              </button>
              <nav className="flex flex-col space-y-4 mt-10">
                <Link
                  to="/"
                  className="text-lg font-semibold text-black hover:text-[#12AD63] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Home
                </Link>
                <Link
                  to="/terms-and-condition"
                  className="text-lg font-semibold text-black hover:text-[#12AD63] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Terms & Conditions
                </Link>
              </nav>
            </div>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="privacy-policy-container mx-auto lg:px-[72px] xl:px-[190px] 2xl:px-[270px] bg-[#ffffff]">
        <div className="w-full h-auto flex justify-center items-center pt-20 md:pt-0">
          <div className="container mx-auto px-2 py-8 text-justify text-[15px] text-black">
            <h1 className="text-4xl font-extrabold text-center mb-3 text-black">
              Terms & Conditions
            </h1>
            <br />
            <div
              className="terms-content whitespace-pre-line mb-8 text-black"
              dangerouslySetInnerHTML={{ __html: termsAndConditionsContent }}
            />
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollToTop && (
        <button
          onClick={scrollToTop}
          className="rounded-scroll-to-top"
          aria-label="Scroll to top"
        >
          <IoChevronUp size={24} />
        </button>
      )}

      <div className="bg-[#eeeeee]">
        <Footer />
      </div>
    </>
  );
};

export default TermsAndCondition;
